import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-favorite-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './favorite-button.component.html',
  styleUrls: ['./favorite-button.component.scss']
})
export class FavoriteButtonComponent implements OnChanges {
  @Input() isFavorited = false;
  @Input() isLoading = false;
  @Input() disabled = false;
  @Input() title = '';

  @Output() favoriteToggle = new EventEmitter<void>();

  // Animation states
  isAnimating = false;
  showHeartBurst = false;
  showPulse = false;

  // Track previous favorite state for animation detection
  private previousFavoriteState: boolean | null = null;
  ngOnChanges(changes: SimpleChanges): void {
    // Trigger animation when favorite status changes and we're not loading
    if (changes['isFavorited'] && !changes['isFavorited'].firstChange && !this.isLoading) {
      // Only animate if the previous state was set (to avoid animating on initial load)
      if (this.previousFavoriteState !== null) {
        this.triggerAnimation();
      }
    }

    // Update previous state
    if (changes['isFavorited']) {
      this.previousFavoriteState = this.isFavorited;
    }
  }

  onClick(): void {
    if (this.disabled || this.isLoading) {
      return;
    }

    this.favoriteToggle.emit();
  }

  private triggerAnimation(): void {
    if (this.isAnimating) {
      return; // Prevent overlapping animations
    }

    this.isAnimating = true;

    if (this.isFavorited) {
      // Animation for favoriting (heart burst + pulse)
      this.showHeartBurst = true;
      this.showPulse = true;

      // Remove heart burst after animation
      setTimeout(() => {
        this.showHeartBurst = false;
      }, 600);

      // Remove pulse after animation
      setTimeout(() => {
        this.showPulse = false;
        this.isAnimating = false;
      }, 800);
    } else {
      // Animation for unfavoriting (shake + fade)
      setTimeout(() => {
        this.isAnimating = false;
      }, 400);
    }
  }
}
